import { createCssVariablesTheme } from 'shiki';

import './code-syntax.css';

export const theme = createCssVariablesTheme();
